import React from 'react';
import { Alert, AlertColor } from '@mui/material';
import texts from 'texts/alert-payment';
import { StatusPayment } from 'helpers/types';

import { Container } from './style';

type Props = {
  status: string;
};

const statusMapping: Record<StatusPayment, { severity: AlertColor; label: string }> = {
  unpaid: { severity: 'error', label: texts.label.unpaid },
  pending: { severity: 'warning', label: texts.label.pending },
  paid: { severity: 'success', label: texts.label.paid }
};

function AlertPayment({ status }: Props) {
  const { severity, label } = statusMapping[status as keyof typeof statusMapping];

  return (
    <Container className='label-payment-status'>
      <Alert variant='filled' severity={severity} className={`payment-status-${status}`}>
        {label}
      </Alert>
    </Container>
  );
}

export default React.memo(AlertPayment);
